import React from 'react';
import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyTrips } from 'api/trips/use-get-many-trips.ts';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params.ts';
import { useTripFiltersStore } from 'shared/stores/use-trip-filters.ts';
import { Pagination } from 'components/pagination';
import { TripCreate } from 'components/trips/trip-create';
import { TripsFilter } from 'components/trips/trips-filter';
import { TripsList } from 'components/trips/trips-list';

export const TripsListPage: React.FC = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { search, filters } = useTripFiltersStore();

  const { data: trips, isLoading, isPreviousData } = useGetManyTrips({ page, limit, search, filters });

  const header = <PageHeader title={<TripsFilter />} extra={[<TripCreate />]} />;

  usePageReset([search, filters]);

  return (
    <DefaultPageLayout header={header}>
      <Skeleton loading={isLoading}>
        <TripsList trips={trips?.data || []} isLoading={isPreviousData} />
        <Pagination
          total={trips?.pagination?.total}
          page={trips?.pagination?.currentPage}
          limit={trips?.pagination?.limit}
          onChange={handlePageChange}
        />
      </Skeleton>
    </DefaultPageLayout>
  );
};
